import { createAxiosClient } from '../axiosDefaults';
const SUBSCRIPTION_API_PATH = "subscription/";
export function createApi(baseUrl, config) {
  let axiosConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const axiosInstance = createAxiosClient({
    baseURL: '/api/v1/',
    withCredentials: true,
    ...axiosConfig
  }, config);

  function subscribeToNewsletter(email) {
    return axiosInstance.post(SUBSCRIPTION_API_PATH, {
      email,
      referrer_id: 'footer_newsletter'
    });
  }

  return {
    subscribeToNewsletter
  };
}